import { ReferenceDataOptionLists } from '../../constants/reference-data-option-lists';
import { Deserializable } from '../deserializable';

export class Fee implements Deserializable {
  public FeeID: number;
  public AdditionalNetworkFee?: number;
  public ArrangementFee?: number;
  public ArrangementFeeIncludedCode: string;
  public BookingFee?: number;
  public HigherLendingCharge?: number;
  public HigherLendingChargeIncludedCode: string;
  public IntermediaryFeeApplication?: number;
  public LandRegistryFee?: number;
  public NonCashInducement?: number;
  public PayableTo: string;
  public ProcurationFee?: number;
  public ReinspectionApplicableCode: string;
  public ReinspectionFee?: number;
  public StandardProcurationFee?: number;
  public SelectionAdvisedCode: string;
  public TotalProcurationFee?: number;
  public IsValuationCompletedBeforeCode: string;
  public ValuationCompletedValue?: number;
  public ValuationCompanyName: string;
  public IsAnyoneAddedToDeeds?: boolean;
  public IntermediaryFeeOffer?: number;
  public IntermediaryFeeCompletion?: number;
  public IntermediaryFeeApplicationRefundableCode: string;
  public IntermediaryFeeOfferRefundableCode: string;
  public IntermediaryFeeCompletionRefundableCode: string;
  public ValuationFee?: number;
  public ValuationReportTypeCode: string;
  public ValuationReportPayerTypeCode: string;
  public WhoCompletedSurvey: string;
  public SubmitViaMortgageClubCode: string;
  public BuildingSurveyValuationFee?: number;
  public HomeBuyersReportValuationFee?: number;
  public MortgageValuationReporttValuationFee?: number;
  public MortgageClubNumber: string;
  public TelegraphicTransferFee?: number;
  public IsValuationReportWithin12Weeks: string;
  public IsRecommendedCode: string;
  public LegalFees?: number;
  public DprVisibleFees: string;
  public DprHiddenFees: string;
  public ArrangementFeeDprId: string;
  public BookingFeeDprId: string;
  public ReinspectionFeeDprId: string;
  public HigherLendingChargeDprId: string;
  public LandRegistryFeeScotlandDprId: string;
  public LandRegistryFeeEnglandAndWalesDprId: string;
  public LandRegistryFeeNIrelandDprId: string;
  public ValuationFeeDprId: string;
  public HomeBuyersReportFeeDprId: string;
  public TelegraphicTransferFeeId: string;
  public AgentID?: number;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }

  setValuationFee(): void {
    let valuationFee;

    switch (this.ValuationReportTypeCode) {
      case ReferenceDataOptionLists.ValuationReportTypeMortgageValuation:
        valuationFee = this.MortgageValuationReporttValuationFee;
        break;
      case ReferenceDataOptionLists.ValuationReportTypeHomeBuyers:
        valuationFee = this.HomeBuyersReportValuationFee;
        break;
      case ReferenceDataOptionLists.ValuationReportTypeBuildingSurvey:
        valuationFee = this.BuildingSurveyValuationFee;
        break;
      default:
        valuationFee = undefined;
    }

    this.ValuationFee = valuationFee;
  }
}
